// First run: with no songs yet, Home leads with the Rhythm Lab and a three-step hint. Shown until it is dismissed or the dancer
// starts something (a song or the lab), then never again on this device.

const KEY = 'salsacount.firstrun';

export function firstRunDone(): boolean {
  try {
    return localStorage.getItem(KEY) === 'done';
  } catch {
    return false;
  }
}

/** Never show the first-run hint again on this device. */
export function finishFirstRun(): void {
  try {
    localStorage.setItem(KEY, 'done');
  } catch {
    /* shown again next visit: harmless */
  }
}
